export const DELETE_INGREDIENT_SUCCESS = 'DELETE_INGREDIENT_SUCCESS';

export const deleteIngredientSuccess = ( id: string ) => ({
    type: DELETE_INGREDIENT_SUCCESS,
    payload: {
        id,
    },
});
